import { AppUser } from '@bechtel/client-common';
import {
  CrewMember,
  MilestoneStatusCode,
  CrewMemberDiscipline,
  PersonaType,
  CommodityAssignee,
  UnitOfMeasure,
  Weld,
  CommodityType,
  WorkPackage,
  AttachmentType,
  MilestoneActivity,
  RejectionType,
  CommodityValueType,
  CommoditySection,
  BlockStatusCode,
  Attachment,
  CrewMemberShiftType,
  CrewMemberAssignment,
  Block,
  CommodityFilterByTerm,
  CommoditySortByTerm,
  SortOrder,
  User,
  RodRoom,
  RodDiameter,
  RodFillerMaterial,
  Rod,
  RodRequest,
  StencilRequest,
  FillerMaterialType,
  RodRequestStatusCode,
  RodRequestFillerMaterial,
  FilterOperator,
  CommodityStatusCode,
} from '@bechtel/types';
import { addDays } from 'date-fns';
import { GET_WELDS, GET_PROJECT_COMMODITY_TYPES_BY_ID } from '@bechtel/client-gql';

const avatarImage0 =
  'data:image/jpeg;base64,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';
const avatarImage1 =
  'data:image/jpeg;base64,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';
const avatarImage2 =
  'data:image/jpeg;base64,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';
const avatarImage3 =
  'data:image/jpeg;base64,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';

export const superAdmin: User = {
  id: '11112259-6faf-4e61-9819-1e9e252cb199',
  firstName: 'Super',
  lastName: 'Admin',
  etrackId: null,
  email: 'asuper@bechtel.com',
  permissions: [],
  crewMember: {
    id: '11112259-6faf-4e61-9819-1e9e252cb199',
    persona: PersonaType.SUPER_ADMIN,
    firstName: 'Super',
    lastName: 'Admin',
  },
  //@ts-ignore all fields not needed here
  project: {
    id: 'a2df66a6-e170-4a69-af04-c9351c669af8',
  },
  roles: [],
  permissionScopes: [],
};

export const documentListMock: Attachment[] = [
  {
    attachmentType: AttachmentType.DOCUMENT,
    createdAt: '2020-06-30T21:45:50.165Z',
    creator: { id: 'c7ef9e9f-01c8-49bb-a0a5-90fe13a2474d', firstName: 'Test', lastName: 'User' },
    fileName: 'pdfsample.pdf',
    fileSize: '83848',
    id: 'cc1e3583-fbaf-40e8-8c1b-e1ae96953b11',
    url: 'http://localhost:8081/attachment?mediaid=cc1e3583-fbaf-40e8-8c1b-e1ae96953b11',
    mimeType: 'application/pdf',
  },
  {
    attachmentType: AttachmentType.DOCUMENT,
    createdAt: '2020-06-30T21:45:50.165Z',
    creator: { id: 'c7ef9e9f-01c8-49bb-a0a5-90fe13a2474d', firstName: 'Test', lastName: 'User' },
    fileName: 'sample.pdf',
    fileSize: '83848',
    id: 'cc1e3583-fbaf-40e8-8c1b-e1ae96953b12',
    url: 'http://localhost:8081/attachment?mediaid=cc1e3583-fbaf-40e8-8c1b-e1ae96953b11',
    mimeType: 'application/pdf',
  },
  {
    attachmentType: AttachmentType.DOCUMENT,
    createdAt: '2020-06-30T21:45:50.165Z',
    creator: { id: 'c7ef9e9f-01c8-49bb-a0a5-90fe13a2474d', firstName: 'Test', lastName: 'User' },
    fileName: 'sample2.pdf',
    fileSize: '83848',
    id: 'cc1e3583-fbaf-40e8-8c1b-e1ae96953b13',
    url: 'http://localhost:8081/attachment?mediaid=cc1e3583-fbaf-40e8-8c1b-e1ae96953b11',
    mimeType: 'application/pdf',
  },
];

export const images: Attachment[] = [
  {
    id: '22e8526a-dd80-432c-9e7f-6d17a110962e',
    url: 'https://www.k-tig.com/hubfs/10%20Tips%20to%20Improve%20the%20Quality%20of%20your%20Welding%20Process.png',
    attachmentType: AttachmentType.IMAGE,
    mimeType: 'image/png',
    fileName: '',
    fileSize: '',
    createdAt: '',
    creator: {
      id: '160b365d-4aab-4a23-8fc2-f232090ff2fc',
      firstName: 'Bayer',
      lastName: 'Kailey',
      imageUrl: 'http://localhost:8081/avatar?etrackid=500006',
      persona: undefined,
    },
  },
  {
    id: '22e8526a-dd80-432c-9e7f-6d17a110962e',
    url: 'https://www.wileymetal.com/wp-content/uploads/2018/10/What-You-Need-to-Know-About-Colored-Welds-1080x675.jpg',
    attachmentType: AttachmentType.IMAGE,
    mimeType: 'image/png',
    fileName: '',
    fileSize: '',
    createdAt: '',
    creator: {
      id: '160b365d-4aab-4a23-8fc2-f232090ff2fc',
      firstName: 'Bayer',
      lastName: 'Kailey',
      imageUrl: 'http://localhost:8081/avatar?etrackid=500006',
      persona: undefined,
    },
  },
  {
    id: '22e8526a-dd80-432c-9e7f-6d17a110962e',
    url:
      'https://www.genesis-systems.com/wp-content/uploads/2019/05/How-robotic-TIG-welding-adds-precision-and-quality-control-to-your-production.jpeg',
    attachmentType: AttachmentType.IMAGE,
    mimeType: 'image/png',
    fileName: '',
    fileSize: '',
    createdAt: '',
    creator: {
      id: '160b365d-4aab-4a23-8fc2-f232090ff2fc',
      firstName: 'Bayer',
      lastName: 'Kailey',
      imageUrl: 'http://localhost:8081/avatar?etrackid=500006',
      persona: undefined,
    },
  },
];

export const milestonesActivityHistory = [
  {
    id: '1',
    dateTime: '2019-10-18T06:30:00Z',
    milestoneStatus: MilestoneStatusCode.BLOCK_RESOLVED,
    crewMember: {
      id: 'f6d4b98b-f2a6-4d13-89c0-480ff19971d1',
      firstName: 'Dave',
      lastName: 'Zanicky',
      imageUrl: 'http://localhost:8081/avatar?etrackid=500006',
      persona: PersonaType.FIELD_ENGINEER,
      discipline: CrewMemberDiscipline.NONE,
    },
    comments: 'Correct materials were used.',
    attachments: [],
  },
  {
    id: '2',
    dateTime: '2019-10-19T06:30:00Z',
    milestoneStatus: MilestoneStatusCode.APPROVED,
    crewMember: {
      id: 'f6d4b98b-f2a6-4d13-89c0-480ff19971d1',
      firstName: 'Dave',
      lastName: 'Zanicky',
      imageUrl: 'http://localhost:8081/avatar?etrackid=500006',
      persona: PersonaType.FIELD_ENGINEER,
      discipline: CrewMemberDiscipline.NONE,
    },
    comments: 'Correct materials were used.',
    attachments: [],
  },
  {
    id: '3',
    dateTime: '2019-10-20T06:30:00Z',
    milestoneStatus: MilestoneStatusCode.APPROVED,
    crewMember: {
      id: 'f6d4b98b-f2a6-4d13-89c0-480ff19971d1',
      firstName: 'Dave',
      lastName: 'Zanicky',
      imageUrl: 'http://localhost:8081/avatar?etrackid=500006',
      persona: PersonaType.FIELD_ENGINEER,
      discipline: CrewMemberDiscipline.NONE,
    },
    comments: 'Correct materials were used.',
    attachments: [],
  },
  {
    id: '4',
    dateTime: '2019-10-21T06:30:00Z',
    milestoneStatus: MilestoneStatusCode.APPROVED,
    crewMember: {
      id: 'f6d4b98b-f2a6-4d13-89c0-480ff19971d1',
      firstName: 'Dave',
      lastName: 'Zanicky',
      imageUrl: 'http://localhost:8081/avatar?etrackid=500006',
      persona: PersonaType.FIELD_ENGINEER,
      discipline: CrewMemberDiscipline.NONE,
    },
    comments: 'Correct materials were used.',
    attachments: [],
  },
];

export const welders: CrewMember[] = [
  {
    id: '34d63b31-46c6-45ec-a76f-73be6c8bc17c',
    firstName: 'RODNEY',
    lastName: 'AARON',
    imageUrl: avatarImage0,
    persona: PersonaType.CRAFT,
  },
  {
    id: '94b27a68-ad99-418d-bb10-d64b9119c8d5',
    firstName: 'ROLANDO',
    lastName: 'ABREGO',
    imageUrl: avatarImage1,
    persona: PersonaType.CRAFT,
  },
];

export const weldSuperintendent: CrewMember = {
  id: '1c0d249a-27f8-4204-a845-ad3a47480fea',
  firstName: 'Ryan',
  lastName: 'Munro',
  persona: PersonaType.SUPERINTENDENT,
  imageUrl: avatarImage2,
};

export const weldGeneralForeman: CrewMember = {
  id: '2c56f19a-8134-41fe-93db-46c64061d619',
  firstName: 'CHRISTOPHER',
  lastName: 'Henry',
  persona: PersonaType.GENERAL_FOREMAN,
  imageUrl: avatarImage2,
};

export const weldForeman: CrewMember = {
  id: '898b7ef5-3887-481d-ba7e-e22328190153',
  firstName: 'Benjamin',
  lastName: 'Henry',
  persona: PersonaType.FOREMAN,
  imageUrl: avatarImage2,
};

export const weldFieldEngineer: CrewMember = {
  id: '4',
  firstName: 'Ryan',
  lastName: 'Bridwell',
  persona: PersonaType.FIELD_ENGINEER,
  imageUrl: avatarImage3,
};

export const commodityAssignees: CommodityAssignee[] = [
  { assignee: welders[0], personaType: PersonaType.CRAFT },
  { assignee: welders[1], personaType: PersonaType.CRAFT },
  { assignee: weldForeman, personaType: PersonaType.FOREMAN },
  { assignee: weldGeneralForeman, personaType: PersonaType.GENERAL_FOREMAN },
  { assignee: weldSuperintendent, personaType: PersonaType.SUPERINTENDENT },
  { assignee: weldFieldEngineer, personaType: PersonaType.FIELD_ENGINEER },
];

export const assignedCrewMembersMock: CrewMemberAssignment[] = [
  {
    persona: PersonaType.FOREMAN,
    crewMember: {
      id: '898b7ef5-3887-481d-ba7e-e22328190153',
      imageUrl: '',
      firstName: 'Elyssa',
      lastName: 'Friesen',
    },
  },
  {
    persona: PersonaType.GENERAL_FOREMAN,
    crewMember: {
      id: '2c56f19a-8134-41fe-93db-46c64061d619',
      imageUrl: '',
      firstName: 'Welch',
      lastName: 'Maddison',
    },
  },
  {
    persona: PersonaType.SUPERINTENDENT,
    crewMember: {
      id: '251a65c4-31d3-46ad-8146-dedef5d6476c',
      imageUrl: '',
      firstName: 'Boulceester',
      lastName: 'Winch',
    },
  },
  {
    persona: PersonaType.FIELD_ENGINEER,
    crewMember: {
      id: 'ce1dbef3-5e33-43e5-b5d3-feb836d0d930',
      imageUrl: '',
      firstName: 'Rooseton',
      lastName: 'Winston',
    },
  },
];

export const otherOwnersMock: CrewMemberAssignment[] = [
  {
    persona: PersonaType.FOREMAN,
    crewMember: {
      id: '48d40ceb-49f6-4912-ba21-5c5ff789d54d',
      shiftType: CrewMemberShiftType.NIGHT,
      imageUrl: '',
      firstName: 'Al',
      lastName: 'Kumar',
    },
  },
  {
    persona: PersonaType.GENERAL_FOREMAN,
    crewMember: {
      id: '920b6bc8-e3dc-40b8-b89c-fb6ddb986a97',
      shiftType: CrewMemberShiftType.NIGHT,
      imageUrl: '',
      firstName: 'Ford',
      lastName: 'Harrison',
    },
  },
  {
    persona: PersonaType.SUPERINTENDENT,
    crewMember: {
      id: 'a1e533f8-8d6f-41ce-b85d-84ff7cd8ac56',
      shiftType: CrewMemberShiftType.NIGHT,
      imageUrl: '',
      firstName: 'Rayleigh',
      lastName: 'Rich',
    },
  },
  {
    persona: PersonaType.FIELD_ENGINEER,
    crewMember: {
      id: 'a1e533f8-8d6f-41ce-b85d-84ff7cd8ac60',
      imageUrl: '',
      firstName: 'Ravi',
      lastName: 'Kumar',
    },
  },
];

export const secondaryOwnersMock: CrewMemberAssignment[] = [
  {
    persona: PersonaType.FOREMAN,
    crewMember: {
      id: '10a7853e-790a-4793-aac5-51a46f725b64',
      imageUrl: '',
      firstName: 'Waugh',
      lastName: 'Mark',
    },
  },
  {
    persona: PersonaType.GENERAL_FOREMAN,
    crewMember: {
      id: '0e6c5c28-1057-43bd-804f-c538dd9fbeee',
      imageUrl: '',
      firstName: 'Smith',
      lastName: 'Steve',
    },
  },
  {
    persona: PersonaType.SUPERINTENDENT,
    crewMember: {
      id: '16b28801-6e2f-496b-b13c-c9d235a4f814',
      imageUrl: '',
      firstName: 'Blake',
      lastName: 'Jason',
    },
  },
  {
    persona: PersonaType.FIELD_ENGINEER,
    crewMember: {
      id: '16b28801-6e2f-496b-b13c-c9d235a4f909',
      imageUrl: '',
      firstName: 'Deepak',
      lastName: 'Kumar',
    },
  },
];
//@ts-ignore all workpackge info not needed for weld mock
export const wpWeldMock: WorkPackage = {
  id: 'WorkPackage1',
  tag: 'PSG-233D01-8792C',
  primaryOwners: assignedCrewMembersMock,
  secondaryOwners: secondaryOwnersMock,
  otherOwners: otherOwnersMock,
};

const weldListSectionsMock: CommoditySection[] = [
  {
    title: 'Weld Details',
    fields: [
      {
        name: 'Design Code',
        value: 'N/A',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'NDE Required',
        value: 'Yes',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'NDE Inspection Group',
        value: 'RT 5',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Post Weld Heat Treat (PWHT) Required',
        value: 'Yes',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Closure Weld',
        value: 'No',
        valueType: CommodityValueType.TEXT,
      },
    ],
  },
  {
    title: 'Technicals',
    fields: [
      {
        name: 'End Type',
        value: 'Butt Weld',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Pipe Spec',
        value: 'A3',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Material Class',
        value: 'C1E',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Fluid Code',
        value: 'NI',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Diameter',
        value: '2',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Wall Thickness',
        value: '0.514',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Schedule',
        value: 'S-STD',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Associated Spool',
        value: '233D02-23RM-16340-02-1',
        valueType: CommodityValueType.TEXT,
      },
    ],
  },
  {
    title: 'Packaging',
    fields: [
      {
        name: 'Startup System',
        value: '339-04',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Hydro Package Number',
        value: '339-04-003-F-NI',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'Vendor Tag',
        value: 'N/A',
        valueType: CommodityValueType.TEXT,
      },
      {
        name: 'IWP Number',
        value: 'PSG-233N01-0032A',
        valueType: CommodityValueType.TEXT,
      },
    ],
  },
  {
    title: 'Remarks',
    fields: [
      {
        name: '',
        value: 'NDE complete ready for paint',
        valueType: CommodityValueType.LONG_TEXT,
      },
    ],
  },
];

export const accessBlock: Block = {
  attachment: [],
  comments: [
    {
      id: 'e3a361c1-f646-40a8-94f3-6047c728dae6',
      comment: 'testing',
      createdAt: '2020-02-06T11:09:58Z',
      createdBy: {
        id: 'twuser_up_cc',
        firstName: 'Jhon',
        lastName: 'David',
        persona: PersonaType.SUPERINTENDENT,
      },
    },
  ],
  commodityMilestoneIds: ['438A51D3-6864-49D7-A655-CA1153B86965'],
  creator: {
    id: '967817d2-e62a-4bbe-9fc4-213553f219ad',
    imageUrl: '',
    firstName: 'Welch',
    lastName: 'Maddison',
  },
  currentStatusI18n: BlockStatusCode.BLOCK_OPENED,
  id: 'b091d409-3d36-41ba-b485-043e4e457ae0',
  impactedCommodities: [],
  impactedMilestones: [],
  statusHistory: [
    {
      id: '31db86f2-7158-4efd-a7f7-65f011e0a35e',
      codeI18n: BlockStatusCode.BLOCK_OPENED,
      createdAt: '2021-01-16T00:26:15',
      createdBy: {
        id: 'twuser_up_cc',
        firstName: 'TeamWorks',
        lastName: 'User',
        persona: PersonaType.SUPERINTENDENT,
      },
    },
  ],
  type: {
    id: 'block-type-0',
    title: 'BLOCK_TYPE_TITLE_ACCESS',
    description: 'BLOCK_TYPE_DESCRIPTION_ACCESS',
    sortOrder: 1,
  },
  workPackage: wpWeldMock,
};
export const interferenceBlock: Block = {
  attachment: [],
  comments: [
    {
      id: '31db86f2-7158-4efd-a7f7-65f011e0a35e',
      comment: 'testing',
      createdAt: '2021-11-18T08:19:04.630Z',
      createdBy: {
        id: '16589aba-b288-4ec5-8bc6-b50367414976',
        firstName: 'Pawan',
        lastName: 'Kumar',
        persona: PersonaType.SUPERINTENDENT,
      },
    },
  ],
  commodityMilestoneIds: ['438A51D3-6864-49D7-A655-CA1153B86965'],
  creator: {
    id: '16589aba-b288-4ec5-8bc6-b50367414976',
    imageUrl: '',
    firstName: 'Pawan',
    lastName: 'kumar',
  },
  currentStatusI18n: BlockStatusCode.BLOCK_OPENED,
  id: 'd90504c6-927e-4258-a7fa-e97c8292274d',
  impactedCommodities: [],
  impactedMilestones: [],
  statusHistory: [
    {
      id: '31db86f2-7158-4efd-a7f7-65f011e0a35e',
      codeI18n: BlockStatusCode.BLOCK_OPENED,
      createdAt: '2021-01-16T00:26:15',
      createdBy: {
        id: '16589aba-b288-4ec5-8bc6-b50367414976',
        imageUrl: '',
        firstName: 'Pawan',
        lastName: 'kumar',
      },
    },
  ],
  type: {
    id: 'block-type-2',
    title: 'BLOCK_TYPE_TITLE_INTERFERENCE',
    description: 'BLOCK_TYPE_DESCRIPTION_INTERFERENCE',
    sortOrder: 1,
  },
  workPackage: wpWeldMock,
};

export const projectCommodityTypes: CommodityType[] = [
  {
    id: 'Pipe',
    lobCommodityCode: 'Pipe',
    lobCommodityTypeId: 'Pipe',
    lobTemplateCode: 'Pipe',
    lobTemplateTypeId: 'Pipe',
    name: 'Pipe',
    //@ts-ignore all project info not needed for weld mock
    project: {
      name: 'Corpus',
    },
    projectMilestoneTypes: [],
    sortOrder: 1,
    unitOfMeasure: UnitOfMeasure.HOURS,
  },
  {
    id: 'project-commodity-type-1-6',
    lobCommodityCode: 'Weld',
    lobCommodityTypeId: 'Weld',
    lobTemplateCode: 'Weld',
    lobTemplateTypeId: 'Weld',
    name: 'Weld',
    //@ts-ignore all project info not needed for weld mock
    project: {
      name: 'Corpus',
    },
    projectMilestoneTypes: [],
    sortOrder: 1,
    unitOfMeasure: UnitOfMeasure.HOURS,
  },
];
/**this array have only ready to weld data */
export const readyToWeldList: Weld[] = [
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C9',
    tag: '4J03001X-RPL450828-FW-02-C09',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.READY_TO_WELD,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 62,
    status: {
      id: '1b54fdae-32df-4a6d-8050-2758402ac683',
      nameI18n: CommodityStatusCode.READY_TO_WELD,
      status: CommodityStatusCode.READY_TO_WELD,
    },
    pipeMaterial: 'P5',
    isPriority: false,
    commodityAssignees: commodityAssignees,
    applicableWeldProcedures: ['P8-TM(STT)(CVN-320F)[B31.3]', 'P1-AT-LH(BHN-CVN-50)(ER70S-6)'],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 41.67,
      longitude: -50.33,
      elevation: 30.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '5b333d1d-cc05-413f-930b-865ca72caf9e',
    tag: '4J03001X-RPL450828-FW-02-C05',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac68e3',
          codeI18n: MilestoneStatusCode.READY_TO_WELD,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 93,
    status: {
      id: '1b54fdae-32df-4a6d-8050-2758402ac68e2e23',
      nameI18n: CommodityStatusCode.READY_TO_WELD,
      status: CommodityStatusCode.READY_TO_WELD,
    },
    pipeMaterial: 'P5',
    isPriority: false,
    commodityAssignees: [],
    applicableWeldProcedures: ['P8-TM(STT)(CVN-320F)[B31.3]'],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 71.67,
      longitude: -38.33,
      elevation: 57.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C11',
    tag: '4J03001X-RPL450828-FW-02-C10',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-80e50-2758402ac683',
          codeI18n: MilestoneStatusCode.READY_TO_WELD,
          activity: MilestoneActivity.CLAIMED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 10,
    status: {
      id: '1b54fdae-32df-4a6d-8e050-2758402ac68223',
      nameI18n: CommodityStatusCode.READY_TO_WELD,
      status: CommodityStatusCode.READY_TO_WELD,
    },
    pipeMaterial: 'P5A',
    isPriority: false,
    commodityAssignees: [],
    applicableWeldProcedures: ['P8-TM(STT)(CVN-320F)[B31.3]', 'P1-FT(AR-C02)(BHN)'],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 41.67,
      longitude: -50.33,
      elevation: 30.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
];

export const rodRoomAttendantsMock: CrewMember[] = [
  {
    id: '1',
    firstName: 'Ricky',
    lastName: 'Martin',
    badgeNumber: 'P-01',
    imageUrl: avatarImage0,
  },
  {
    id: '2',
    firstName: 'Jeniifer',
    lastName: 'Michael',
    badgeNumber: 'P-02',
    imageUrl: avatarImage1,
  },
];

export const rodRoomMockList: RodRoom[] = [
  {
    id: 'rod-room-01',
    name: 'Rod Room - 001',
    //@ts-ignore Schema update required.
    code: 'RR-001',
    location: {
      latitude: 0,
      longitude: 0,
      elevation: undefined,
    },
    locationDescription: 'West to Column B7 - OSBL',
  },
  {
    id: 'rod-room-02',
    name: 'Rod Room - 002',
    //@ts-ignore Schema update required.
    code: 'RR-002',
    location: {
      latitude: 0,
      longitude: 0,
      elevation: undefined,
    },
    locationDescription: 'Southeast to Column A3 - ECU',
  },
];
export const foremanList: CrewMember[] = [
  {
    id: 'ce3dfcc3-b0c9-4940-b4b9-5940ecb12cbf',
    firstName: 'Cameron',
    lastName: 'Stover',
    imageUrl: avatarImage0,
    shiftType: null,
    persona: PersonaType.FOREMAN,
    crew: {
      id: '1',
      crewNumber: 'WP-010',
    },
  },
  {
    id: 'f6d4b98b-f2a6-4d13-89c0-480ff19971d1',
    firstName: 'Dave',
    lastName: 'Zanicky',
    imageUrl: avatarImage1,
    shiftType: null,
    persona: PersonaType.FOREMAN,
    crew: {
      id: '1',
      crewNumber: 'WP-010',
    },
  },
  {
    id: 'ac4b7058-14a1-4c8c-b956-7d69f8c0d7ae',
    firstName: 'Steve',
    lastName: 'Thieme',
    imageUrl: avatarImage2,
    shiftType: null,
    persona: PersonaType.FOREMAN,
    crew: {
      id: '1',
      crewNumber: 'WP-010',
    },
  },
];

export enum PickupTimeTerm {
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  PAST_DAYS = 'PAST_DAYS',
}

export const bareRodDiameter: RodDiameter = {
  id: '1',
  //@ts-ignore Schema update required.
  label: '1/8',
};

export const bareRodFillerMaterial: RodFillerMaterial = {
  id: 'filler-material-01',
  label: '9889RFB-80',
  //@ts-ignore Schema update required.
  type: FillerMaterialType.BARE,
  rodDiameters: [bareRodDiameter],
};

export const rodDiameterList = [
  {
    id: 'diameter-01',
    label: '1/2',
  },
  {
    id: 'diameter-02',
    label: '1/8',
  },
  {
    id: 'diameter-03',
    label: '3/32',
  },
];

export const rodRequestFillerMaterial: RodRequestFillerMaterial = {
  id: 'filler-material-01',
  fillerMaterial: {
    id: 'filler-material-01',
    label: '9889RFB-80',
    type: FillerMaterialType.BARE,
    rodDiameters: rodDiameterList,
  },
  diameters: rodDiameterList,
};

export const requestRodsDetail: Rod[] = [
  {
    fillerMaterial: bareRodFillerMaterial,
    diameter: bareRodDiameter,
    //@ts-ignore Schema update required.
    lotNumber: { id: '08221', label: '08221', value: '08221' },
    rodContainer: { id: '2864HFB-88', label: '2864HFB-88', value: '2864HFB-88' },
  },
  {
    fillerMaterial: bareRodFillerMaterial,
    diameter: bareRodDiameter,
    //@ts-ignore Schema update required.
    lotNumber: { id: '102920', label: '102920', value: '102920' },
    rodContainer: { id: '2864HFB-89', label: '2864HFB-89', value: '2864HFB-89' },
  },
  {
    fillerMaterial: bareRodFillerMaterial,
    diameter: bareRodDiameter,
    //@ts-ignore Schema update required.
    lotNumber: { id: '103005', label: '103005', value: '103005' },
    rodContainer: { id: '2864HFB-90', label: '2864HFB-90', value: '2864HFB-90' },
  },
];

export const issuedRodsDetail: Rod[] = [
  {
    fillerMaterial: bareRodFillerMaterial,
    diameter: bareRodDiameter,
    //@ts-ignore Schema update required.
    lotNumber: { id: '103071', label: '103071', value: '103071' },
    rodContainer: { id: '2864HFB-91', label: '2864HFB-91', value: '2864HFB-91' },
  },
  {
    fillerMaterial: bareRodFillerMaterial,
    diameter: bareRodDiameter,
    //@ts-ignore Schema update required.
    lotNumber: { id: '103282', label: '103282', value: '103282' },
    rodContainer: { id: '2864HFB-92', label: '2864HFB-92', value: '2864HFB-92' },
  },
];

export const requestedRods: StencilRequest[] = [
  {
    stencil: welders[0],
    rods: requestRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[0],
    status: RodRequestStatusCode.REQUESTED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
  {
    stencil: welders[1],
    rods: requestRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[0],
    status: RodRequestStatusCode.REQUESTED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
];

export const partialIssuedRods: StencilRequest[] = [
  {
    stencil: welders[0],
    rods: issuedRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[0],
    status: RodRequestStatusCode.PARTIAL_ISSUED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
  {
    stencil: welders[0],
    rods: issuedRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[0],
    status: RodRequestStatusCode.ISSUED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
];
export const issuedRods: StencilRequest[] = [
  {
    stencil: welders[0],
    rods: issuedRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[0],
    status: RodRequestStatusCode.ISSUED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
  {
    stencil: welders[1],
    rods: issuedRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[0],
    status: RodRequestStatusCode.ISSUED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
];
export const expiredRods: StencilRequest[] = [
  {
    stencil: welders[0],
    rods: requestRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[1],
    status: RodRequestStatusCode.EXPIRED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
  {
    stencil: welders[1],
    rods: requestRodsDetail,
    //@ts-ignore Schema update required.
    isPickupForOthers: false,
    pickupFor: [],
    issuedBy: rodRoomAttendantsMock[0],
    status: RodRequestStatusCode.EXPIRED,
    isWelded: false,
    isWeldComplete: false,
    issuedAt: '2022-01-24T06:30:00Z',
    pickupTime: '2022-01-25T06:30:00Z',
  },
];

export const requestedRodDetail: RodRequest = {
  id: '100',
  requestNumber: 'RR01FM22-100',
  welds: [readyToWeldList[0], readyToWeldList[1]],
  stencils: welders,
  currentStatusI18n: RodRequestStatusCode.REQUESTED,
  rodRoom: rodRoomMockList[0],
  pickUpTime: PickupTimeTerm.TOMORROW,
  comments: [
    {
      id: 'comment-id-1',
      comment: 'Welder prefers 3/32 ',
      createdAt: '2022-01-17T06:30:00Z',
      createdBy: welders[0],
    },
  ],
  createdBy: foremanList[0],
  createdAt: '2022-01-17T06:30:00Z',
  //@ts-ignore Schema update required.
  weldProcedure: {
    id: 'P8-TM(STT)(CVN-320F)[B31.3]',
    procedure: 'P8-TM(STT)(CVN-320F)[B31.3]',
  },
  fillerMaterials: [rodRequestFillerMaterial],
};

export const issuedRodDetail: RodRequest = {
  id: '101',
  requestNumber: 'RR01FM22-101',
  welds: [readyToWeldList[0], readyToWeldList[1]],
  stencils: welders,
  currentStatusI18n: RodRequestStatusCode.ISSUED,
  rodRoom: rodRoomMockList[0],
  pickUpTime: PickupTimeTerm.TODAY,
  comments: [
    {
      id: 'comment-id-1',
      comment:
        'Welder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 sec…',
      createdAt: '2022-01-17T06:30:00Z',
      createdBy: welders[0],
    },
  ],
  createdBy: foremanList[0],
  createdAt: '2022-02-24T06:30:00Z',
  //@ts-ignore Schema update required.
  weldProcedure: {
    id: '102F01-00CHW-01-W-0ZS00YJA-C1',
    procedure: '102F01-00CHW-01-W-0ZS00YJA-C1',
  },
  fillerMaterials: [rodRequestFillerMaterial],
};

export const partialIssuedRodDetail: RodRequest = {
  id: '102',
  requestNumber: 'RR01FM22-102',
  welds: [readyToWeldList[0], readyToWeldList[1]],
  stencils: welders,
  currentStatusI18n: RodRequestStatusCode.PARTIAL_ISSUED,
  rodRoom: rodRoomMockList[0],
  pickUpTime: PickupTimeTerm.TODAY,
  comments: [
    {
      id: 'comment-id-1',
      comment:
        'Welder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 sec…',
      createdAt: '2022-01-17T06:30:00Z',
      createdBy: welders[0],
    },
  ],
  createdBy: foremanList[0],
  createdAt: '2022-02-22T06:30:00Z',
  //@ts-ignore Schema update required.
  weldProcedure: {
    id: '102F01-00CHW-01-W-0ZS00YJA-C2',
    procedure: '102F01-00CHW-01-W-0ZS00YJA-C2',
  },
  fillerMaterials: [rodRequestFillerMaterial],
};

export const expiredRodDetail: RodRequest = {
  id: '103',
  requestNumber: 'RR01FM22-103',
  welds: [readyToWeldList[0], readyToWeldList[1]],
  stencils: welders,
  currentStatusI18n: RodRequestStatusCode.EXPIRED,
  rodRoom: rodRoomMockList[0],
  pickUpTime: PickupTimeTerm.TODAY,
  comments: [
    {
      id: 'comment-id-1',
      comment:
        'Welder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 secWelder prefers 3/32 sec…',
      createdAt: '2022-01-17T06:30:00Z',
      createdBy: welders[0],
    },
  ],
  createdBy: foremanList[0],
  createdAt: '2022-02-23T06:30:00Z',
  //@ts-ignore Schema update required.
  weldProcedure: {
    id: '4',
    procedure: '102F01-00CHW-01-W-0ZS00YJA-C3',
  },
  fillerMaterials: [rodRequestFillerMaterial],
};

export const weldListMock: Weld[] = [
  { ...readyToWeldList[2] },
  { ...readyToWeldList[1] },
  {
    ...readyToWeldList[0],
  },
  {
    id: 'c70a37a7-e5cd-477f-ae9c-c24902c7f80d',
    applicableWeldProcedures: ['P8-TM(STT)(CVN-320F)[B31.3]'],
    // attachments: [...documentListMock, ...images],
    pipeDiameter: 10,
    status: { status: CommodityStatusCode.CLAIMED, id: '123', nameI18n: CommodityStatusCode.CLAIMED },
    pipeMaterial: 'P5A',
    isPriority: true,
    commodityAssignees: commodityAssignees,
    earnedHours: 0,
    totalEarnableHours: 0,
    isNDERequired: false,
    isoDocument: {
      documentNumber: '204A01-20HC-24813-13',
      url: 'http://localhost:8088/isodocument?documentnumber=204A01-20HC-24813-13',
      commodity: {},
    },
    location: {
      latitude: 27.71007,
      longitude: -97.34512,
      elevation: 40.8,
    },
    locationDescription:
      'Vent recovery on the ground inside the compressor deck (middle area). Weld is a 66”SS silver line on jack stands.',
    milestones: [
      {
        id: 'weld1',
        name: 'Install',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.CLAIMED,
          activity: MilestoneActivity.CLAIMED,
          rejectionType: null,
          comments: null,
          createdAt: '2018-08-29T00:00:00Z',
          createdBy: {
            id: 'twuser_up_cc',
            firstName: 'TeamWorks',
            lastName: 'User',
            persona: PersonaType.SUPERINTENDENT,
          },
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    sections: weldListSectionsMock,
    tag: '4J03001X-RPL450828-FW-02-C00',
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    weldedWithProcedure: 'P8-TM(STT)(CVN-320F)[B31.3]',
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C2',
    tag: '4J03001X-RPL450828-FW-02-C02',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    // attachments: [...documentListMock, ...images],
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.SENT_BACK_TO_PIPING,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 30,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275s8402ac68223',
      nameI18n: CommodityStatusCode.SENT_BACK_TO_PIPING,
      status: CommodityStatusCode.SENT_BACK_TO_PIPING,
    },
    pipeMaterial: 'P1',
    isPriority: true,
    commodityAssignees: [],
    applicableWeldProcedures: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '204A01-20HC-24813-13',
      url: 'http://localhost:8088/isodocument?documentnumber=204A01-20HC-24813-13',
      commodity: {},
    },
    location: {
      latitude: 27.70826,
      longitude: -97.34326,
      elevation: 30.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C3',
    tag: '4J03001X-RPL450828-FW-02-C03',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.BLOCKED,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [interferenceBlock],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 34,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275s8402ac68223',
      nameI18n: CommodityStatusCode.BLOCKED,
      status: CommodityStatusCode.BLOCKED,
    },
    pipeMaterial: 'HDPE',
    isPriority: false,
    commodityAssignees: commodityAssignees,
    applicableWeldProcedures: [],
    // attachments: documentListMock,
    earnedHours: 0,
    sections: [],
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '233U01-23AD-12694-01',
      url: 'http://localhost:8088/isodocument?documentnumber=233U01-23AD-12694-01',
      commodity: {},
    },
    location: {
      latitude: 27.70741,
      longitude: -97.34191,
      elevation: 39.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C31',
    tag: '4J03001X-RPL450828-FW-02-C031',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-275840f2ac683',
          codeI18n: MilestoneStatusCode.BLOCKED,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [accessBlock, interferenceBlock],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 34,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275ss8402ac68223',
      nameI18n: CommodityStatusCode.BLOCKED,
      status: CommodityStatusCode.BLOCKED,
    },

    pipeMaterial: 'P5',
    isPriority: false,
    commodityAssignees: commodityAssignees,
    applicableWeldProcedures: [],
    // attachments: documentListMock,
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '233U01-23AD-12694-01',
      url: 'http://localhost:8088/isodocument?documentnumber=233U01-23AD-12694-01',
      commodity: {},
    },
    location: {
      latitude: 27.70851,
      longitude: -97.33932,
      elevation: 39.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C4',
    tag: '4J03001X-RPL450828-FW-02-C04',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.CLAIMED,
          activity: MilestoneActivity.CLAIMED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 28,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275s8402acg68223',
      nameI18n: CommodityStatusCode.CLAIMED,
      status: CommodityStatusCode.CLAIMED,
    },
    pipeMaterial: 'P2',
    isPriority: false,
    commodityAssignees: commodityAssignees,
    applicableWeldProcedures: [],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 27.71071,
      longitude: -97.34108,
      elevation: 29.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '5b333d1d-cc05-413f-930b-865ca72caf9ea',
    tag: '4J03001X-RPL450828-FW-02-C05',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.READY_TO_WELD,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 93,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275s84ss02acg68223',
      nameI18n: CommodityStatusCode.READY_TO_WELD,
      status: CommodityStatusCode.READY_TO_WELD,
    },
    pipeMaterial: 'P5',
    isPriority: false,
    commodityAssignees: [],
    applicableWeldProcedures: [],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 27.70918,
      longitude: -97.33889,
      elevation: 57.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C6',
    tag: '4J03001X-RPL450828-FW-02-C06',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.SENT_BACK_TO_PIPING,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 30,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275s84ss02acg68223',
      nameI18n: CommodityStatusCode.SENT_BACK_TO_PIPING,
      status: CommodityStatusCode.SENT_BACK_TO_PIPING,
    },
    pipeMaterial: 'P3',
    isPriority: true,
    commodityAssignees: commodityAssignees,
    applicableWeldProcedures: [],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 27.71031,
      longitude: -97.34101,
      elevation: 38.5,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C7',
    tag: '4J03001X-RPL450828-FW-02-C07',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32dfs-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.VT_APPROVED,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 46,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275s84ss02acg68223',
      nameI18n: CommodityStatusCode.VT_APPROVED,
      status: CommodityStatusCode.VT_APPROVED,
    },
    pipeMaterial: 'HDPE',
    isPriority: true,
    commodityAssignees: [],
    applicableWeldProcedures: [],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 27.70948,
      longitude: -97.34155,
      elevation: 30.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C8',
    tag: '4J03001X-RPL450828-FW-02-C08',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.VT_SENT_BACK,
          activity: MilestoneActivity.REJECTED,
          rejectionType: { id: '1', reason: RejectionType.WORK_NOT_COMPLETE },
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 39,
    status: {
      id: '1b54fdae-32df-4a6d-8050-275s84ss02acg68223',
      nameI18n: CommodityStatusCode.VT_SENT_BACK,
      status: CommodityStatusCode.VT_SENT_BACK,
    },
    pipeMaterial: 'P2',
    isPriority: false,
    commodityAssignees: commodityAssignees,
    applicableWeldProcedures: [],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 27.70902,
      longitude: -97.34265,
      elevation: 30.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C91',
    tag: '4J03001X-RPL450828-FW-02-C09',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.READY_TO_WELD,
          activity: MilestoneActivity.PLANNED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 62,
    status: {
      id: '1b54fdae-32df-4a6d-8050-27d5s84ss02acg68223',
      nameI18n: CommodityStatusCode.READY_TO_WELD,
      status: CommodityStatusCode.READY_TO_WELD,
    },
    pipeMaterial: 'P5',
    isPriority: false,
    commodityAssignees: commodityAssignees,
    applicableWeldProcedures: [],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 27.71017,
      longitude: -97.34295,
      elevation: 30.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C10',
    tag: '4J03001X-RPL450828-FW-02-C10',
    locationDescription: 'Vent recovery on the ground inside the compressor deck',
    milestones: [
      {
        id: 'weld1',
        name: 'ELT',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac683',
          codeI18n: MilestoneStatusCode.READY_TO_WELD,
          activity: MilestoneActivity.CLAIMED,
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    pipeDiameter: 10,
    status: {
      id: '1b54fdae-32df-4a6d-8050-27d5s84ss02qcg68223',
      nameI18n: CommodityStatusCode.READY_TO_WELD,
      status: CommodityStatusCode.READY_TO_WELD,
    },
    pipeMaterial: 'P5A',
    isPriority: false,
    commodityAssignees: [],
    applicableWeldProcedures: [],
    // attachments: [],
    earnedHours: 0,
    sections: weldListSectionsMock,
    totalEarnableHours: 0,
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    isoDocument: {
      documentNumber: '25873-001-P3-6TST005X-AI851431-04',
      url: 'http://localhost:8088/isodocument?documentnumber=233D01-23RM-16310-01',
      commodity: {},
    },
    location: {
      latitude: 27.71163,
      longitude: -97.34111,
      elevation: 30.8,
    },
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
  // TODO: Uncomment this once ASSIGNED status added to MilestoneStatusCode
  {
    id: '102F01-00CHW-57002-01-W-0ZS00YJA-C1',
    applicableWeldProcedures: ['P8-TM(STT)(CVN-320F)[B31.3]'],
    // attachments: [...documentListMock, ...images],
    pipeDiameter: 10,
    status: {
      id: '1b54fdae-32df-4a6d-8050-a27d5s84ss02acg68223',
      nameI18n: CommodityStatusCode.FITUP_INSPECTION,
      status: CommodityStatusCode.FITUP_INSPECTION,
    },
    pipeMaterial: 'P5A',
    isPriority: true,
    commodityAssignees: commodityAssignees,
    earnedHours: 0,
    totalEarnableHours: 0,
    isNDERequired: false,
    isoDocument: {
      documentNumber: '204A01-20HC-24813-13',
      url: 'http://localhost:8088/isodocument?documentnumber=204A01-20HC-24813-13',
      commodity: {},
    },
    location: {
      latitude: 46.67,
      longitude: -80.33,
      elevation: 40.8,
    },
    locationDescription:
      'Vent recovery on the ground inside the compressor deck (middle area). Weld is a 66”SS silver line on jack stands.',
    milestones: [
      {
        id: '102F01-00CHW-57002-01-W-0ZS00YJA-C1',
        name: 'Install',
        hours: 30,
        timesRejected: 0,
        attachments: [],
        currentStatus: {
          id: '1b54fdae-32df-4a6d-8050-2758402ac699',
          codeI18n: MilestoneStatusCode.CLAIMED,
          activity: MilestoneActivity.CLAIMED,
          rejectionType: null,
          comments: null,
          createdAt: '2018-08-29T00:00:00Z',
          createdBy: {
            id: 'twuser_up_cc',
            firstName: 'TeamWorks',
            lastName: 'User',
            persona: PersonaType.SUPERINTENDENT,
          },
        },
        blocks: [],
        isExpired: false,
        commodity: {},
        workPackageId: '',
        type: { id: '', name: '', itrRequired: false, projectItrConfig: [] },
        quantity: { quantity: 0, unitOfMeasure: UnitOfMeasure.LINEAR_FEET },
      },
    ],
    sections: weldListSectionsMock,
    tag: '102F01-00CHW-57002-01-W-0ZS00YJA-C1',
    type: projectCommodityTypes[0],
    workPackage: wpWeldMock,
    weldedWithProcedure: 'P8-TM(STT)(CVN-320F)[B31.3]',
    milestonesActivityHistory: {
      total: 50,
      items: milestonesActivityHistory,
      cursor: '0',
    },
  },
];

export const foremanUser: AppUser = {
  id: 'MOCKED_FM_USER_ID_1',
  crewMember: {
    id: '1',
    persona: PersonaType.FOREMAN,
    firstName: '',
    lastName: '',
  },
  firstName: '',
  lastName: '',
  permissionScopes: [],
  permissions: [],
  roles: [],
};

export const generalForemanUser: AppUser = {
  id: 'MOCKED_GF_USER_ID_1',
  crewMember: {
    id: '1',
    persona: PersonaType.GENERAL_FOREMAN,
    firstName: '',
    lastName: '',
  },
  firstName: '',
  lastName: '',
  permissionScopes: [],
  permissions: [],
  roles: [],
};

export const superintendentUser: AppUser = {
  id: 'MOCKED_SUP_USER_ID_1',
  crewMember: {
    id: '1',
    persona: PersonaType.SUPERINTENDENT,
    firstName: '',
    lastName: '',
  },
  firstName: '',
  lastName: '',
  permissionScopes: [],
  permissions: [],
  roles: [],
};

export const weldListMockRequest = {
  request: {
    query: GET_WELDS,
    variables: {
      input: {
        complexFilter: {
          and: [
            {
              term: CommodityFilterByTerm.COMMODITY_TYPE_ID,
              value: projectCommodityTypes[1].id,
              operator: FilterOperator.EQUALS,
            },
            {
              term: CommodityFilterByTerm.ASSIGNED_CREW_MEMBER,
              value: 'true',
              operator: FilterOperator.EQUALS,
            },
            {
              term: CommodityFilterByTerm.PRIMARY_CREW_MEMBER_ID,
              value: superAdmin.crewMember.id,
              operator: FilterOperator.EQUALS,
            },
          ],
          or: [],
        },
        sortByFilter: {
          term: CommoditySortByTerm.TAG,
          sortOrder: SortOrder.DESC,
        },
      },
      paging: {
        cursor: '0',
        limit: 10,
      },
    },
  },
  result: {
    data: {
      commodities: {
        cursor: '1',
        total: 3,
        items: [{ weld: weldListMock[0] }, { weld: weldListMock[1] }, { weld: weldListMock[2] }],
      },
    },
  },
};

export const noWeldListMockRequest = {
  request: {
    query: GET_WELDS,
    variables: {
      input: {
        complexFilter: {
          and: [
            {
              term: CommodityFilterByTerm.COMMODITY_TYPE_ID,
              value: projectCommodityTypes[1].id,
              operator: FilterOperator.EQUALS,
            },
            {
              term: CommodityFilterByTerm.PRIMARY_CREW_MEMBER_ID,
              value: superAdmin.crewMember.id,
              operator: FilterOperator.EQUALS,
            },
            {
              term: CommodityFilterByTerm.ASSIGNED_CREW_MEMBER,
              value: 'true',
              operator: FilterOperator.EQUALS,
            }
          ],
          or: [],
        },
        sortByFilter: {
          term: CommoditySortByTerm.TAG,
          sortOrder: SortOrder.DESC,
        },
      },
      paging: {
        cursor: '1',
        limit: 20,
      },
    },
  },
  result: {
    data: {
      commodities: {
        cursor: '1',
        total: 0,
        items: [],
      },
    },
  },
};

export const projectCommodityTypesMockRequest = {
  request: {
    query: GET_PROJECT_COMMODITY_TYPES_BY_ID,
    variables: {
      ids: [superAdmin.project?.id],
    },
  },
  result: {
    data: {
      projectsByIds: [
        {
          id: 'a2df66a6-e170-4a69-af04-c9351c669af8',
          projectConfiguration: {
            id: 'a2df66a6-e170-4a69-af04-c9351c669af8',
            projectCommodityTypes: projectCommodityTypes,
          },
        },
      ],
    },
  },
};
